<template>
  <div class="personGroup_wrap section-main__warp">
    <div class="personGroup_left">
      <ioc-table ref="groupTableRef" :data="groupData" :option="constData.groupTable"
        @search-change="(val) => { handleSearchChange(val, 'group'); }"
        @search-reset="(val) => { handleSearchReset('group'); }" @row-click="handleRowClick">
        <template slot="menuLeft">
          <div>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addGroupShow">新增人员群组</el-button>
          </div>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip class="item m5" effect="dark" content="修改" placement="top-start">
            <el-button type="text" class="el-icon-edit-outline" @click="handleUpdGroup(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item m5" effect="dark" content="删除" placement="top-start">
            <el-button type="text" class="el-icon-delete" @click="handleDelGroup(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </ioc-table>
    </div>
    <el-dialog :title="addGroupTitle" :visible.sync="addGroupVisible" append-to-body :close-on-click-modal="modalClose"
      width="30%">
      <el-form :model="addGroupForm" ref="addGroupForm" :rules="addGroupRules" label-width="120px">
        <el-form-item label="群组名称" prop="personnelGroupName">
          <el-input v-model="addGroupForm.personnelGroupName" placeholder="请输入群组名称" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addGroupConfirm('addGroupForm')">确 定</el-button>
        <el-button @click="addGroupCancel">取 消</el-button>
      </div>
    </el-dialog>
    <div class="personGroup_right">
      <ioc-table ref="personTableRef" :data="personData" :option="constData.personTable"
        @search-change="(val) => { handleSearchChange(val, 'person'); }"
        @search-reset="(val) => { handleSearchReset('person'); }">
        <template slot="menuLeft">
          <div>
            <el-button type="primary" icon="el-icon-circle-plus-outline" size="small"
              @click="handleAddPeople">添加人员</el-button>
          </div>
        </template>
        <template slot="img" slot-scope="scope">
          <img :src="getImgPath(scope.row.facePicFileCode)"
            @click="showViewer(getImgPath(scope.row.facePicFileCode), $event)"
            onerror="this.src='/images/theme/newDark/default.png'" style="height: 50px; width: 50px; cursor: pointer" />
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip class="item m5" effect="dark" content="移除" placement="top-start">
            <el-button type="text" class="el-icon-remove-outline" @click="handleDelGroupPerson(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </ioc-table>
    </div>
    <peopleSelect :selectGroup="selectGroup" :showPeoplePanel="showPeoplePanel"
      @handleClosePeoplePanel="handleClosePeoplePanel"></peopleSelect>
  </div>
</template>

<script>
import { Bus } from "$utils";
import { api } from "../api/index";
import { groupTable } from "../config/groupTable";
import { personTable } from "../config/personTable";
import peopleSelect from "../components/peopleSelect"
export default {
  components: {
    peopleSelect
  },
  data() {
    return {
      constData: {
        groupTable: groupTable(true),
        groupSearchForm: {},
        personTable: personTable(true),
        personSearchForm: {}
      },
      groupData: [],
      modalClose: false,
      addGroupTitle: '',
      addGroupVisible: false,
      addGroupForm: {
        personnelGroupCode: null,
        personnelGroupName: null
      },
      addGroupRules: {
        personnelGroupName: [{ required: true, message: '请输入群组名称', trigger: ['blur', 'change'] }]
      },
      personData: [],
      checkGroup: {
        personnelGroupCode: null
      },
      selectGroup: '',
      showPeoplePanel: false,
    }
  },
  mounted() {
    this.groupGetList()
  },
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(src, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 查询群组列表
    groupGetList() {
      let params = {
        ...this.constData.groupSearchForm,
      };
      this.$fetch(api.queryPersonnelgroup, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.groupData = res.returnObj;
        let row = { ...this.groupData[0] };
        this.$refs.groupTableRef.$refs.multipleTable.setCurrentRow(row);
        this.handleRowClick(row);
      });
    },
    // 条件搜索
    handleSearchChange(param, type) {
      this.constData[`${type}SearchForm`] = Object.assign({}, param);
      this[`${type}GetList`]();
    },
    // 条件重置
    handleSearchReset(type) {
      this.constData[`${type}SearchForm`] = {};
      this[`${type}GetList`]();
    },
    // 点击群组获取人员
    handleRowClick(row) {
      this.checkGroup.personnelGroupCode = row.personnelGroupCode;
      this.personGetList()
    },
    // 新增群组
    addGroupShow() {
      this.addGroupTitle = '新增人员群组'
      this.addGroupForm.personnelGroupCode = null
      this.addGroupForm.personnelGroupName = null
      this.addGroupVisible = true
    },
    addGroupConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addGroupForm.personnelGroupCode) {
            let params = {
              personnelGroupCode: this.addGroupForm.personnelGroupCode,
              personnelGroupName: this.addGroupForm.personnelGroupName
            }
            this.$fetch(api.updatePersonnelgroup, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addGroupVisible = false
                this.groupGetList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              personnelGroupName: this.addGroupForm.personnelGroupName
            }
            this.$fetch(api.addPersonnelgroup, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addGroupVisible = false
                this.groupGetList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    addGroupCancel() {
      this.addGroupVisible = false
    },
    // 修改群组
    handleUpdGroup(row) {
      this.addGroupTitle = '修改人员群组'
      this.addGroupForm.personnelGroupCode = row.personnelGroupCode
      this.addGroupForm.personnelGroupName = row.personnelGroupName
      this.addGroupVisible = true
    },
    // 删除
    handleDelGroup(row) {
      const params = {
        personnelGroupCode: row.personnelGroupCode
      };
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.delPersonnelgroup, params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.groupGetList()
        });
      });
    },
    // 根据群组查询人员
    personGetList() {
      let params = {
        ...this.constData.personSearchForm,
        personnelGroupCode: this.checkGroup.personnelGroupCode
      };
      this.$fetch(api.queryPersonnelByGroup, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.personData = res.returnObj;
      });
    },
    // 人员弹窗
    handleAddPeople() {
      if (this.checkGroup.personnelGroupCode) {
        this.selectGroup = this.checkGroup.personnelGroupCode;
        this.showPeoplePanel = true;
      } else {
        this.$message({
          message: '请先选择群组',
          type: 'warning'
        });
      }
    },
    handleClosePeoplePanel() {
      this.showPeoplePanel = false;
      this.personGetList()
    },
    // 从群组移除人员
    handleDelGroupPerson(row) {
      const params = {
        personnelCodes: [row.personnelCode],
        personnelGroupCode: this.checkGroup.personnelGroupCode
      };
      const groupName = row.personnelGroupName
      const peopleName = row.name
      this.$confirm(`您确定要将 ${peopleName} 从 ${groupName} 移除吗?`, "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.deleteGroupPersonnel, params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.personGetList()
        });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.personGroup {
  &_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  &_left {
    width: 600px;
    height: 100%;
  }

  &_right {
    width: calc(100% - 616px);
    height: 100%;
  }
}
</style>